import { Provider } from '@angular/core';

import {
	DEFAULT_DUPLICATE_REQUEST_WINDOW_MS,
	DEFAULT_MAX_SENTRY_EVENTS_PER_FINGERPRINT,
} from '../config/duplicate-request-monitoring.constants';
import { DuplicateRequestMonitoringOptions } from '../config/duplicate-request-monitoring-options.interface';
import { DUPLICATE_REQUEST_MONITORING_OPTIONS } from '../config/duplicate-request-monitoring-options.token';
import { DUPLICATE_REQUEST_REPORTER } from '../config/duplicate-request-reporter.token';
import { SentryDuplicateRequestReporterService } from './sentry-duplicate-request-reporter.service';

export function provideDuplicateRequestMonitoring(options: DuplicateRequestMonitoringOptions): Provider[] {
	return [
		{
			provide: DUPLICATE_REQUEST_MONITORING_OPTIONS,
			useValue: {
				...options,
				duplicateWindowMs: options.duplicateWindowMs ?? DEFAULT_DUPLICATE_REQUEST_WINDOW_MS,
				maxSentryEventsPerFingerprint:
					options.maxSentryEventsPerFingerprint ?? DEFAULT_MAX_SENTRY_EVENTS_PER_FINGERPRINT,
			} satisfies DuplicateRequestMonitoringOptions,
		},
		{
			provide: DUPLICATE_REQUEST_REPORTER,
			useExisting: SentryDuplicateRequestReporterService,
		},
	];
}
